<template>
	<div>
		<NavHeader/>
		<div class="main-header-content">
			<div class="container">
				<h3>FREQUENTLY ASKED QUESTIONS</h3>
			</div>
		</div>

		<div class="divider"></div>
		<div class="container">
			<div class="information-detail">
				<privacy-sidebar />

				<div class="information-content">
					<h6 class="info-header"><span style="text-decoration: underline;">Basic Information</span></h6>
					<div class="faq-content">
						<h6 class="question-header">1. What is eRemit?</h6>

						<p class="content-para">eRemit is a secure global money transfer service offered by Merchantrade Asia Sdn Bhd, a licensed money services business provider (money transfers).</p>
					</div>

					<div class="faq-content">
						<h6 class="question-header">2. Who is eligible to use for the eRemit service?</h6>

						<p class="content-para">Any individual who is 18 to 90 years, and who possesses a valid photo identification document together with a Malaysian internet banking account.
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">3. What is On Behalf transaction? </h6>

						<p class="content-para">This refers to a Sender who is performing a transaction On Behalf of another person. For this situation, Sender is required to key in On Behalf person’s details during transaction. </p>
					</div>

					<h6 class="info-header"><span style="text-decoration: underline;">Registration Process</span></h6>
					<div class="faq-content">
						<h6 class="question-header">1. How do I create an account with eRemit?</h6>

						<p class="content-para">
							Visit our website at www.eremit.com.my or Download eRemit app at <a href="http://bit.ly/eRemitGooglePlayStore" target="_blank">http://bit.ly/eRemitGooglePlayStore</a>  or 
						<a href="http://bit.ly/eRemitAppleAppStore" target="_blank">http://bit.ly/eRemitAppleAppStore</a> and signup for a new account with your phone number.
						</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">2. How can I verify my account?</h6>
						<p class="content-para">a) <span style="text-decoration: underline;"> Online Document Verification – eKYC </span></p>
							<ul class="faq-list" style="list-style-type:none">
							<li>STEP 1: Download the mobile application and create/login to your account</li>
							<li>STEP 2: Initiate an eKYC application</li>
							<li>STEP 2: Fill in your details</li>
							<li>STEP 3: Snap and upload your ID documents (Original Mykad or Passport)</li>
							<li>STEP 4: Take a photo of yourself for verification</li>
							<li>STEP 5: Add your signature</li>
							<li>STEP 6: Verification completed</li>
							</ul>
						<h6 class="info-header">OR</h6>
						<p class="content-para">b) <span style="text-decoration: underline;"> Face to face Document Verification – KYC </span></p>
						<ul class="faq-list" style="list-style-type:none">
						<li>STEP 1: Visit any of our nearest branch for identity verification process. <a href="https://eremit.com.my/contact-us-branch-location.aspx" target="_blank">Click here</a> for the full list of Merchantrade branch locations</li>
						<li>STEP 2: Fill up registration form </li>
						<li>STEP 3: Provide your ID documents (Original Mykad or Passport)</li>
						<li>STEP 4: Verification completed</li>
						</ul>
						<p class="note">
							Note: If you are in Klang Valley area, we offer free pickup service and verification of your identification documents. We will arrange our Marketing Executive to visit your place of residence or office.
						</p>
						<p class="content-para">Please send an email with the following details to 
						<a href="javascript:void(0)">customercare@eremit.com.my </a></p>
						<h6 class="info-header">Subject: EREMIT DOCUMENTS COLLECTION</h6>
						<ul class="faq-list">
						<li>Address of Residence/Office</li>
						<li>Mobile Number</li>
						<li>Preferred Date & Time of Visit</li>
						</ul>		
					</div>
					<div class="faq-content">
						<h6 class="question-header">3. What is eKYC?</h6>

						<p class="content-para">eKYC (electronic Know Your Customer)  is an online non face to face customer identification and verification process that is conducted digitally via the eRemit mobile app. The process can be completed at your convenience with an internet connection. </p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">4. Why do I need to submit Identification documents i.e. Mykad and Passport?</h6>

						<p class="content-para">Customer need to be identified against acceptable identification documents in accordance with the Company’s standard Customer Due Diligence process and regulatory requirements. </p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">5. How do I submit my new ID document once my old ID expires?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Email the latest scan of your ID to <a href="javascript:void(0)">customercare@eremit.com.my </a> for account updating purpose and to continue your seamless experience with eRemit. </li>
						<li style="list-style-type: square"><strong>Subject: Update ID Document </strong></li>
							<p>Document to email:</p>
							<p><span class="arrow">&#10148;</span> Passport-Front page/Visa(optional)</p>
							<p><span class="arrow">&#10148;</span> Other IDs-Front and back images</p>
						<p class="Note">
							Note : Ensure the ID shared is in full view, captured under good lighting and without a glaring effect on the image shared.
						</p>
						<li style="list-style-type: square">You will receive an email once your details have been updated.</li>
						<li style="list-style-type: square">Please be informed after your ID expires, you will not be able to perform any transaction. </li>
						</ul>
					</div>
					<h6 class="info-header"><span style="text-decoration: underline;">Update Account</span></h6>
					
					<h6 class="info-header"><span style="text-decoration: underline;">WEB USERS</span></h6>
					<div class="faq-content">
						<h6 class="question-header">1. How do I change my Email Address?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; select Change Email &gt; route to Change Email page &gt; enter New Email and Confirm New Email field &gt; click on “Save Email” to save changes or click “Cancel” to drop changes.</li>
						<li style="list-style-type: square">System logs out and the user gets a notification Email Change Successful on Web.</li>
						<li style="list-style-type: square">User is required to validate the email and re-login.</li>
						</ul>
					</diV>
					<div class="faq-content">
						<h6 class="question-header">2. How do I change my Mobile Phone Number?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; select Change Phone Number &gt; route to Change Phone Number Page &gt; enter New Phone Number and Confirm New Phone Number &gt; enter Password &gt; click Update</li>
						<li style="list-style-type: square">OTP sent to customer new Phone Number &gt; user enters OTP &gt; gets Success notification.</li>
						<li style="list-style-type: square">User required to re-login.</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">3. How do I reset my Password?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; Select Change Password &gt; enter Old Password &gt; Enter New Password &gt; Enter Confirm New Password &gt; click on Save Password to save changes or click on ‘Cancel’ to drop changes.</li>
						<li style="list-style-type: square">System logs out and the user gets a notification on Password Change Successful. </li>
						<li style="list-style-type: square">User required to re-login</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">4. How do I update my Profile?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; select Change Profile &gt; route to Change Profile page &gt; user to update profile &gt; click on ‘Update’ to save changes or ‘Cancel’ to drop the changes.</li>
						<li style="list-style-type: square">System route to User dashboard.</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">5. How do I change my Security Phrase?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; select Change Security Phrase &gt; enter login password &gt; route to Change Security Phrase page &gt; user insert phrase &gt; click on confirm &gt; route to Change Security Confirmation pop-up &gt; Click on ‘YES’ to confirm or ‘NO’ to cancel &gt; OTP sent to customer &gt; insert OTP and Confirm> route to Change Security Phrase Update page &gt; click on ‘OK’ > system logs out.</li>
						<li style="list-style-type: square">User required to re-login.</li>
					    </ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">6. How do I add my Debit Card details?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; Manage Debit Card &gt; route to Manage Debit Card Page &gt; allow to delete (click dustbin) or Add new card</li>
						<li style="list-style-type: square">Add new card &gt; click on Please Add Your New Debit Card &gt; system route to Ipay88 page &gt; insert card details &gt; route to bank page > enter MSOS code </li>
						<li style="list-style-type: square">Success at adding card should be displayed at Manage Debit Card list</li>
					    </ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">7. Upgrade your Account Limit.</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Upgrade Your Account Limit &gt; download form</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">8. How do I deactivate my eRemit account?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; select Change Profile and click on ‘Delete Account’ button.</li>
						</ul>
					</div>
					<h6 class="info-header"><span style="text-decoration: underline;">APP USERS</span></h6>

					<div class="faq-content">
						<h6 class="question-content">1. How do I change my Email Address?</h6>
					    <ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select setting &gt; select Change Email &gt; enter login password &gt; route to Change Email page > enter ‘New Email ‘and ‘Confirm New Email’ field &gt; click on “Update Email” &gt; Pop-up Email Changed successfully displayed.</li>
						<li style="list-style-type: square">Systems logs out</li>
						<li style="list-style-type: square">User is required ti validate the email and re-login</li>
					    </ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">2. How do I change my Mobile Phone Number?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; select ‘Change Phone Number’ &gt; enter login password &gt; route to Change Phone Number Page &gt; enter ‘New Phone Number’ &gt; click on ‘Update Phone Number’ &gt; enter Confirmation Code (OTP) &gt; click on Verify &gt; Pop-up Phone number changed successfully displayed &gt; click on ‘OK’.</li>
						<li style="list-style-type: square">User required to re-login.</li>
						</ul>
				    </div>
					<div class="faq-content">
						<h6 class="question-header">3. How do I reset my Password?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select setting &gt; Select Change Password &gt; enter login password &gt; route to Change Password page &gt; Enter New Password &gt; Enter Confirm New Password &gt; click on Update Password &gt; Pop-up Password changed successfully displayed &gt; click on ‘OK’.</li>
						<li style="list-style-type: square">System logs out and the user gets a notification on Password Change Successful.</li>
						<li style="list-style-type: square">User required to re-login</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">4. How do I update my Profile?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on the main menu button &gt; click on ‘Profile Image’ &gt; route to My profile page &gt; click ‘Save’ for changes.</li>
						 <P>or</P>
						<li style="list-style-type: square">Click on the main menu button &gt; click on ‘Profile Image’ > route to My profile page &gt; click on ‘DELETE ACCOUNT’ to close eRemit account.</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">5.How do I change my Security Phrase?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Setting &gt; select Change Security Phrase &gt; enter login password &gt; route to Change Security Phrase page &gt; user insert phrase &gt; click on confirm &gt; route to Change Security Confirmation pop-up &gt; Click on ‘YES’ to confirm or ‘NO’ to cancel &gt; OTP sent to customer &gt; insert OTP and Confirm> route to Change Security Phrase Update page > click on ‘OK’ &gt; system logs out.</li>
						<li style="list-style-type: square">User required to re-login.</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">6. How do I add my Debit Card details?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select Debit Card &gt; route to Debit Card Page &gt; 'Add a New Debit Card' &gt; system route to Ipay88 page &gt; insert card details &gt; click on 'Next' &gt; route to bank page &gt; enter MSOS code.</li>
						<li style="list-style-type: square">Successfully added card should be displayed at 'Manage Debit Card' list.</li>
						<p>or</p>
						<li style="list-style-type: square">Click on Menu &gt; select Debit Card &gt; route to Debit Card Page &gt; allow to delete (click on dustbin)</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">7. How do I upgrade my Account Limit?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select ‘Setting’ &gt; select ‘Upgrade Your Account Limit’ &gt; download form. Once form is completed, please send email to <a href="javascript:void(0)">customercare@eremit.com.my </a></li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">8. How do I change my Passcode?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Click on Menu &gt; select ‘Setting’ &gt; select ‘Change Passcode’ &gt; enter login password &gt; route to Change Passcode &gt; Enter current passcode &gt; Create New Passcode &gt; Confirm New Passcode &gt; route back to main page.</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">9. Unable to receive TAC.</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">This situation arises when attempt to login is done via a different device.</li>
						<li style="list-style-type: square">eRemit services are secured by device binding during registration.</li>
						<li style="list-style-type: square">If you would like to bind your eRemit account to a new device, our staff will contact you for verification purposes.</li>
						<li style="list-style-type: square">Please send an email with the following details to <a href="javascript:void(0)">customercare@eremit.com.my </a> </li>
						<p><strong>Subject: Unable to receive TAC </strong></p>
						    <ul>
							<li style="list-style-type: disc">Mobile Number</li>
							<li style="list-style-type: disc">Preferred date & Time to call</li>
							</ul>
						<li style="list-style-type: square">We will assist to change the binding to your new device upon verification is completed.</li>
						<li style="list-style-type: square">Once verification process is completed, please ‘Logout’ and ‘Login’ from your new mobile device in order to proceed with your transaction.</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">10.	How do I deactivate my eRemit account?</h6>
						<ul class="faq-list">
						<li style="list-style-type: square">Select on ‘Profile’ and click on ‘Delete Account’ button.</li>
						</ul>
					</div>
					<h6 class="info-header"><span style="text-decoration: underline;">Transaction Process</span></h6>					
					<div class="faq-content">
						<h6 class="question-header">1. How can I send money?</h6>

						<p class="content-para"> Login to your account, create a recipient profile, enter bank details and you are ready to transact.</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">2. Are there any additional charges imposed on the recipient for the eRemit service?</h6>
						<p class="content-para">No charges will be imposed on the Recipient. </p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">3. Do I have to enter the recipient's details every time I transfer money?</h6>

						<p class="content-para"> eRemit captures and retains particulars of your recipients. However, you can make changes to recipient's particulars prior to authorising the payment.</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">4. How do I check the status of my transaction(s)?</h6>

						<p class="content-para"> The transaction status can be viewed on "Transaction History" page.</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">5. What is the exchange rate applicable for my transaction?</h6>

						<p class="content-para">The exchange rate will be the displayed rate at the point of your confirmation of transaction. This rate will be reflected in the remittance receipt. </p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">6. What are the available modes of payment to the recipient?</h6>
						<ul class="faq-list">
								<li>Bank Account Credit</li>
								<li>Cash Pick up</li>
								<li>eWallet</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">7. How do I make payment for my remittance request?</h6>
						<ul class="faq-list">
							<li>FPX (direct deduction from your internet banking account)
								<p class="note">Note: FPX is a convenient and secure online payment solution that allows real-time debiting of customer's internet banking account of multiple banks. </p>
							</li>
							<li>Merchantrade Money Visa Prepaid Card</li>
								<p class="content-para">A reloadable prepaid card to keep cash, for withdrawals or make payments</p>
							<li>Debit Card</li>
							   <p class="content-para">Direct deduction from your registered bank card</p>
						</ul>						
					</div>
					<div class="faq-content">
						<h6 class="question-header">8. Do I get a receipt for my transactions?</h6>
						<p class="content-para">A remittance receipt will be issued and can be downloaded at the Transaction History page. </p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">9. Can I amend / cancel a transaction?</h6>

						<p class="content-para">Amendments or cancellations can only be done if the transaction has not been paid or credited into the recipient’s account. Kindly contact our Customer Care Consultants immediately. </p>
						<p class="note">Note: Merchantrade Asia Sdn Bhd shall not be responsible for any Payout to the wrong person or entity arising from any erroneous data input by the Sender.</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">10. Why is the transfer to the recipient unsuccessful and funds returned? </h6>
						<p class="content-para">The most common reasons are incorrect details (e.g. account number and name of beneficiary) submitted on the payment details.  You will be notified when the funds are returned to us, you can either request the transfer to be reprocessed or refunded.</p>
					</div>
					<div class="faq-content">
						<h6 class="question-header">11.	How do I Reprocess a transaction?</h6>
						<p class="content-para">Login to eRemit account &gt; Go to ‘History’ &gt; Click on ‘Reprocess’ &gt; Key in amended receiver’s details.</p>
					</div>
					<div class="faq-question">
						<h6 class="question-header">12.	How do I fill in refund details?</h6>
						<p class="content-para">Login to eRemit account &gt; Go to ‘History’ &gt; Click on ‘Transaction’ &gt; Select ‘Refund Enable’ &gt; key in refund details.</p>
					</div>
					<h6 class="info-header"><span style="text-decoration: underline;">Transfer Amount Limit</span></h6>
					<div class="faq-content">
						<h6 class="question-header">1. How much can I send?</h6>
						<p class="content-para">(a) <span style="text-decoration: underline;"> Face to face Document Verification – KYC </span></p>
						<p class="content-para">You may transact a maximum of 15 transactions within the last 30 days but your total transactions value per day must not exceed RM50,000. </p>
						<p class="content-para">In the event your total transaction(s) value exceeds RM20,000 per day you may be required to submit supporting documents to facilitate the transaction. </p>
						<p class="content-para">Note: FPX maximum limit per transaction is RM 30,000 subject to the daily internet banking limit set by the banks.</p>
						<p class="content-para">(b) <span style="text-decoration: underline;"> Online Document Verification – eKYC </span></p>
						<ul class="faq-list">
							<li>If you are a Malaysian or an expatriate, you are allowed to transfer a daily maximum limit of RM 30,000 only.</li>
							<li>If you are a migrant worker, you are allowed to transfer up to RM 5,000 within the last 30 days to your home country only.</li>
						</ul>
						<p class="content-para">(c) <span style="text-decoration: underline;"> KYC and eKYC customers</span></p>
						<ul class="faq-list">
							<li>Merchantrade Money Visa Prepaid Card - same as per limit set on the card</li>
							<li>Debit Card-RM5,000 per transaction</li>
						</ul>
					</div>
					<div class="faq-content">
						<h6 class="question-header">2. How do I increase my transaction limit to RM50,000?</h6>
						<p class="content-para">Please send an email with the following details to <a href="javascript:void(0)">customercare@eremit.com.my </a> and our Marketing agent will contact you for verification purposes</p>
						<p class="content-para"><strong>Subject</strong>: Increase my transaction limit to RM50000</p>
						<ul class="faq-list">
						<li>Mobile Number</li>
						<li>Preferred date & Time to call</li>
						</ul>
					</div>
					<h6 class="info-header"><span style="text-decoration: underline;">EREMIT CUSTOMER CARE </span></h6>
					<div class="faq-content">
						<h6 class="question-header">1. How can I contact the Customer Care consultants?</h6>

						<p class="content-para">We're open from 9am to 6pm daily including public holidays.</p>

						<p class="content-para">
							<img src="/static/commercial/img/icons/01call.png" alt="" class="contact-icons">
							<a href="tel:+60383138606">+603-8313 8606 / +603-7724 2070</a>
						</p>

						<!-- <p class="content-para">
							<img src="/static/commercial/img/icons/01fax.png" alt="" class="contact-icons">
							<a href="fax:+60377241811">Fax +6 03 7724 1811</a>
						</p> -->

						<p class="content-para">
							<img src="/static/commercial/img/icons/01mail.png" alt="" class="contact-icons">
							<a href="mailto:customercare@eremit.com.my">customercare@eremit.com.my</a>
						</p>
					</div>
				</div>
			</div>
		</div>


		<div class="divider"></div>
	</div>
</template>
<script>
	import DownloadApp from "../../shared/commercial/DownloadApp.vue";
	import NavHeader from "../../shared/commercial/NavHeader.vue";
	import PrivacySidebar from "../../components/privacysidebar.vue"
	import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";
	export default {
		name: 'faq',
		components: { DownloadApp, NavHeader, SignUpFooter, PrivacySidebar },
	}
</script>
